export enum PasswordStrengths {
  Weak = 1,
  Moderate = 2,
  Strong = 3,
  VeryStrong = 4,
  Complete = 5
}
